/**
 * WEB-957 — реестр текстур покрытия скретч-карты.
 *
 * ЕДИНСТВЕННАЯ точка правды об URL текстур. Этап 3 выполнен 2026-08-02:
 * четыре текстуры сгенерированы (imagen4) и залиты в R2
 * (bucket quiz-builder-assets, ключи scratch-covers/*.jpg, JPEG ≤225КБ,
 * immutable-кэш). fallbackColor остаётся постером под загрузку картинки.
 */

import { pickStrings } from '@/i18n';
import { editorStrings } from '@/i18n/dictionaries/editor';
export interface ScratchCoverPreset {
  id: 'gold_foil' | 'silver_foil' | 'kraft' | 'dark';
  label: string;
  /** URL текстуры. Плейсхолдер до этапа 3 — оркестратор проставит R2/CDN. */
  url: string;
  /** Цвет-фолбэк, пока текстура не залита (и как постер под загрузку). */
  fallbackColor: string;
}

// WEB-2330: второй адрес хранилища R2 на новом домене (старый img.testfunnelsdev.click
// не снимается — у выкачанных воронок адрес записан в содержимое).
const TEXTURE_BASE = 'https://img.subster.ai/scratch-covers';

export const SCRATCH_COVER_PRESETS: readonly ScratchCoverPreset[] = [
  // WEB-1874: `label` — геттер, а не поле: подпись читается на языке кабинета
  // в момент обращения, поэтому потребители продолжают писать `preset.label`.
  {
    id: 'gold_foil',
    get label() {
      return pickStrings(editorStrings).scratchCoverGoldFoil;
    },
    url: `${TEXTURE_BASE}/gold-foil.jpg`,
    fallbackColor: '#c9a227',
  },
  {
    id: 'silver_foil',
    get label() {
      return pickStrings(editorStrings).scratchCoverSilverFoil;
    },
    url: `${TEXTURE_BASE}/silver-foil.jpg`,
    fallbackColor: '#b9bec7',
  },
  {
    id: 'kraft',
    get label() {
      return pickStrings(editorStrings).scratchCoverKraft;
    },
    url: `${TEXTURE_BASE}/kraft.jpg`,
    fallbackColor: '#b7906b',
  },
  {
    id: 'dark',
    get label() {
      return pickStrings(editorStrings).scratchCoverDark;
    },
    url: `${TEXTURE_BASE}/dark.jpg`,
    fallbackColor: '#1f2937',
  },
];

export function getScratchCoverPreset(
  id: string | undefined,
): ScratchCoverPreset | undefined {
  return SCRATCH_COVER_PRESETS.find((p) => p.id === id);
}

/** Текстура ещё не залита (этап 3) — рендерим цвет-фолбэк, не битую картинку. */
export function isPlaceholderTextureUrl(url: string): boolean {
  return url.includes('cdn.PLACEHOLDER');
}
